import React from 'react';
import * as S from '../RoomTypeLoader/RoomTypeLoader.styles';

const RoomTypeLoader = () => (
  <S.RoomTypeLoaderWrapDiv>
    <S.RoomTypeLoaderHeaderWrapDiv>
      <S.RoomTypeLoaderHeaderDiv width="42rem">Room Type</S.RoomTypeLoaderHeaderDiv>
      <S.RoomTypeLoaderHeaderDiv width="37.8rem">Rate Plan</S.RoomTypeLoaderHeaderDiv>
      <S.RoomTypeLoaderHeaderDiv width="40rem">Total Payable</S.RoomTypeLoaderHeaderDiv>
    </S.RoomTypeLoaderHeaderWrapDiv>

    <S.RoomTypeLoaderContentWrapDiv>

      <S.RoomTypeLoaderContentLeftDiv>
        <S.RoomTypeLoaderImgDiv></S.RoomTypeLoaderImgDiv>
        <S.RoomTypeLoaderTypeTextDiv></S.RoomTypeLoaderTypeTextDiv>
        <S.RoomTypeLoaderTypeTextDiv></S.RoomTypeLoaderTypeTextDiv>
        <S.RoomTypeLoaderTypeTextDiv></S.RoomTypeLoaderTypeTextDiv>
        <S.RoomTypeLoaderDescpDiv></S.RoomTypeLoaderDescpDiv>
      </S.RoomTypeLoaderContentLeftDiv>

      <S.RoomTypeLoaderContentRightDiv>
        <S.RoomTypeLoaderOptionsDiv>
          <S.RoomTypeLoaderOptionsTextDiv></S.RoomTypeLoaderOptionsTextDiv>
          <S.RoomTypeLoaderOptionsTextDiv></S.RoomTypeLoaderOptionsTextDiv>
          <S.RoomTypeLoaderOptionsTextLargeDiv></S.RoomTypeLoaderOptionsTextLargeDiv>
          <S.RoomTypeLoaderOptionsTextDiv></S.RoomTypeLoaderOptionsTextDiv>
        </S.RoomTypeLoaderOptionsDiv>

        <S.RoomTypeLoaderPriceDiv>
          <S.RoomTypeLoaderPricesTextDiv></S.RoomTypeLoaderPricesTextDiv>
          <S.RoomTypeLoaderPricesSmallTextDiv></S.RoomTypeLoaderPricesSmallTextDiv>
          <S.RoomTypeLoaderPriceLargeTextDiv></S.RoomTypeLoaderPriceLargeTextDiv>
          <S.RoomTypeLoaderPricesSmallTextDiv></S.RoomTypeLoaderPricesSmallTextDiv>
          <S.RoomTypeLoaderPriceDescpDiv></S.RoomTypeLoaderPriceDescpDiv>
          <S.RoomTypeLoaderPricesSmallerTextDiv></S.RoomTypeLoaderPricesSmallerTextDiv>
        </S.RoomTypeLoaderPriceDiv>
      </S.RoomTypeLoaderContentRightDiv>

    </S.RoomTypeLoaderContentWrapDiv>
  </S.RoomTypeLoaderWrapDiv>
);

export default RoomTypeLoader;
